import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import AppointmentPrice from '../AppointmentPrice/AppointmentPriceContainer.js';
import AppointmentTypeToolTipContainer from './AppointmentTypeToolTip/AppointmentTypeToolTipContainer.js';

const AppointmentTypeButton = (_param)=> {
    var { className , icon , labels , toolTip , price , onClickToolTip  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "icon",
        "labels",
        "toolTip",
        "price",
        "onClickToolTip"
    ]);
    return React.createElement("button", swcHelpers.extends({}, rest, {
        className: classnames('appointment-type-button', className)
    }), icon && /*#__PURE__*/ React.createElement("span", {
        className: "appointment-type-button__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon,
        width: 32,
        height: 32,
        viewBox: "0 0 24 24"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "appointment-type-button__text"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "appointment-type-button__name"
    }, labels.name), labels.description && /*#__PURE__*/ React.createElement("span", {
        className: "appointment-type-button__description"
    }, labels.description), price && /*#__PURE__*/ React.createElement(AppointmentPrice, swcHelpers.extends({}, price))), toolTip && onClickToolTip && /*#__PURE__*/ React.createElement(AppointmentTypeToolTipContainer, {
        onClick: onClickToolTip,
        "aria-label": toolTip.title
    }));
};
var AppointmentTypeButton$1 = AppointmentTypeButton;

export { AppointmentTypeButton$1 as default };
//# sourceMappingURL=AppointmentTypeButton.js.map
